import { render, staticRenderFns } from "./FinishedFixturesTable.vue?vue&type=template&id=dbe61702&"
import script from "./FinishedFixturesTable.vue?vue&type=script&lang=js&"
export * from "./FinishedFixturesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports